import React from 'react';
import styled from 'styled-components';
import 'react-toggle/style.css';
import Toggle from 'react-toggle';
import { useSelector, useDispatch } from 'react-redux';
import { toggleDarkMode } from '../state/actions';

import { FaSun, FaMoon } from 'react-icons/fa';
import { Profile, MainNavItems } from '@components';

const Navigation = styled.header`
  background: ${props => props.theme.palette.navigation};
  height: 100vh;
`;

const ThemePicker = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 12px;
`;

const Text = styled.div`
  color: ${props => props.theme.palette.themePicker};
  padding-right: 12px;
`;

export const SideNav = () => {
  const isDarkMode: boolean = useSelector(state => state.app.isDarkMode);
  const dispatch = useDispatch();
  const toggle = isDarkMode => dispatch(toggleDarkMode(isDarkMode));

  return (
    <Navigation>
      <Profile />
      <MainNavItems />
      <ThemePicker>
        <Text>Theme:</Text>
        <Toggle
          defaultChecked={!isDarkMode}
          icons={{
            checked: <FaSun />,
            unchecked: <FaMoon />,
          }}
          onChange={() => toggle(isDarkMode)}
        />
      </ThemePicker>
    </Navigation>
  );
};
